export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8780.252d23ee.jpg";